import Vue from "vue";
import Vuex from "vuex";
import { postTest } from "../../utils/apiFunctions.js";
Vue.use(Vuex);
const state = () => ({
	// TEST VUE STATE
	selectedTest: { testName: "" },
	testDetails: [],
	isLoadingStatusOne: false,
	testAPI: true,
	showTestConfig: false,
	showPreviewTest: false,
	testConfigData: {
		testID: "",
	},
	proctorTestData: {},
	previewLoading: false,
	categories: null,
	subCategories: null,

	proctoringFilter: {
		applyfilter: false,
		selectedTest: [],
		selectedTopic: [],
		searchFilter: "",
	},
});

const getters = {
	// ------------------------
	// -------- TESTS ---------
	// ------------------------
	getTestConfigStatus: (state) => state.showTestConfig,
	getiIsLoadingStatusOne: (state) => state.isLoadingStatusOne,
	getShowTestPreviewStatus: (state) => state.showPreviewTest,
	getProctorTestData: (state) => state.proctorTestData,
	getTestConfigData: (state) => {
		return state.testConfigData;
	},
	getSelectedTest: (state) => state.selectedTest,
	getTestDetails: (state) => state.testDetails,
	TestAPIStatus: (state) => state.testAPI,
	getPreviewLoading: (state) => state.previewLoading,
	getCategories: (state) => state.categories,
	getSubCategories: (state) => state.subCategories,

	// FILTER GETTER
	getProctoringFilter: (state) => state.proctoringFilter,
};

// actions
const actions = {
	// -----------------------
	// ------- TESTS ---------
	// -----------------------

	async saveTestAPIStatus(state, payload) {
		state.commit("saveTestAPIStatus", payload);
	},
	async saveTest(state, payload) {
		let data = await payload;
		try {
			const response = await postTest(data);
			if (response.status == 200) {
				data.testID = response.data.data.testID;
			}
			return response;
		} catch (error) {
			return error;
		}
	},
};
// mutations
const mutations = {
	setPreviewLoading(state, payload) {
		state.previewLoading = payload;
	},

	isLoadingStatusOne(state, payload) {
		state.isLoadingStatusOne = payload;
	},

	// -----------------------
	// -------- TEST----------
	// -----------------------
	saveshowPreviewTest(state, payload) {
		state.showPreviewTest = payload.preview_status;
	},
	saveShowTestConfig(state, payload) {
		state.testConfigData = { ...payload.config_data };
		state.showTestConfig = payload.config_status;
	},
	saveTest(state, payload) {
		state.testDetails = payload;
	},
	saveCurrentTest(state, payload) {
		state.testDetails.unshift(payload);
	},

	saveView(state, payload) {
		state.searchBarListView = payload.list;
		state.searchBarGridView = payload.grid;
	},

	// Test
	saveTestConfig(state, payload) {
		state.testConfig.push(payload);
	},

	saveTestAPIStatus(state, payload) {
		state.testAPI = payload;
	},
	saveProctorTestData(state, payload) {
		state.proctorTestData = payload;
	},
	// Savting selected test details
	saveSelectedTest(state, payload) {
		state.selectedTest.testName = payload;
	},
	saveCategories(state, payload) {
		state.categories = payload;
	},
	saveSubCategories(state, payload) {
		state.subCategories = payload;
	},

	// -------- FILTER MUTATIONS --------
	saveProctoringFilters(state, payload = {}) {
		state.proctoringFilter = {
			...state.proctoringFilter, // existing defaults
			...payload, // override with incoming
		};
	},
	clearProctoringFilters(state) {
		state.proctoringFilter = {
			applyfilter: false,

			selectedTest: [],
			selectedTopic: [],
			searchFilter: "",
		};
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
